import React from 'react';
import {StyleProp, TouchableOpacity, View, ViewStyle} from 'react-native';
import Label from '../../Label';
import {buttonsStyles} from '../boutonStyle';
import PrimaryButton from '../PrimaryButton';
import styles from './styles';

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  cancelAction: Function;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  submitAction: Function;
  cancelTitle: string;
  submitTitle: string;
  underlineType?: boolean;
  isDisable?: boolean;
  style?: StyleProp<ViewStyle>;
}

const SecondaryButton: React.FC<Props> = ({
  cancelAction,
  submitAction,
  cancelTitle = 'Annuler',
  submitTitle = 'Valider',
  underlineType,
  isDisable,
  style = {},
}) => {
  return (
    <View style={[buttonsStyles.displayCenter, style]}>
      <View
        style={[styles.displayHorizontalException, styles.displayHorizontal]}>
        {!underlineType && (
          <PrimaryButton
            onPress={() => cancelAction()}
            styleBtnTxt={buttonsStyles.btnAnnuler}
            styleBtnOuter={buttonsStyles.btnAnnulerOuter}
            title={cancelTitle}
            type="annuler"
          />
        )}
        {underlineType && (
          <TouchableOpacity onPress={() => cancelAction()}>
            <Label title={cancelTitle} type="linkUnderline" />
          </TouchableOpacity>
        )}
        <PrimaryButton
          isDisable={isDisable}
          onPress={submitAction}
          styleBtnTxt={buttonsStyles.btnValider}
          styleBtnOuter={buttonsStyles.btnValiderOuter}
          title={submitTitle}
          type="valider"
        />
      </View>
    </View>
  );
};

export default SecondaryButton;
